import { makeWithContextProviderHOC } from "@contexts/utils";
import React, { createContext, useState } from "react";

const QrModalContext = createContext(null);

const defaultQrModalContext = null;

export const QrContextProvider = ({ children, qrModalContext }) => {
	const [qrModalId, setQrModalId] = useState(
		qrModalContext || defaultQrModalContext,
	);

	const remvoeQrModalContext = () => setQrModalId(defaultQrModalContext);

	return (
		<QrModalContext.Provider
			value={{
				qrModalId,
				setQrModalId,
				remvoeQrModalContext,
			}}
		>
			{children}
		</QrModalContext.Provider>
	);
};

export const withQRContextProvider =
	makeWithContextProviderHOC(QrContextProvider);

export const QrModalConsumer = QrModalContext.Consumer;

export default QrModalContext;
